
import { Component, Model, Prop, Vue } from 'vue-property-decorator';
import { isDesktop } from '@/helpers/isDesktop';
import type { Topic } from '@/models/topic';
import { topicWebservice } from '@/webservices/topic';
import { showErrorNotification } from '@/helpers/showErrorNotification';

@Component({
    name: 'FormTopicPicker',
})
export default class FormTopicPicker extends Vue {
    @Model('input', {
        required: true,
    })
    private topics: Topic[];

    @Prop({
        required: false,
        default: () => [],
    })
    private availableTopics: Topic[];

    @Prop({
        required: false,
        default: () => true,
    })
    private multiple: boolean;

    @Prop({
        required: false,
        default: () => false,
    })
    private topicIsSet: boolean;

    private disabled: boolean = false;

    private defaultTopics: Topic[] = [];

    private isDesktop = isDesktop();

    mounted() {
        if (this.availableTopics.length === 0) {
            this.loadOptions();
        }

        // if (this.topicIsSet) {
        //     this.disabled = true;
        // }
    }

    loadOptions() {
        topicWebservice
            .load()
            .then((response) => {
                const filteredTopics = response.data.filter((topic: Topic) => {
                    return topic.title !== 'Nicht zugeordnete Lehren';
                });

                this.defaultTopics = filteredTopics.sort((a: Topic, b: Topic) => {
                    return a.title.localeCompare(b.title);
                });

                if (this.defaultTopics.length > 0) {
                    this.$emit('loadDefaultTopic', this.defaultTopics[0]);
                }
            })
            .catch(() => {
                showErrorNotification('');
            });
    }

    get selected() {
        return this.topics;
    }

    get available() {
        return this.availableTopics.length > 0 ? this.availableTopics : this.defaultTopics;
    }
}
